import { Directive, TemplateRef, AfterViewInit, inject } from '@angular/core';
import { ZefErrorTemplateService } from '../../error-template.service';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[zefDialogErrorOutlet]',
  standalone: true
})
export class DialogErrorOutletDirective implements AfterViewInit {

  templateRef = inject(TemplateRef<any>);
  #errorTemplate = inject(ZefErrorTemplateService);

  ngAfterViewInit() {
    this.#errorTemplate.setTemplate(
      this.templateRef,
      'dialog'
    );
  }
}
